/* eslint-disable no-use-before-define */

import React from "react";
import {
  Text,
  Keyboard,
  View,
  StyleSheet,
  TextInput,
  Platform,
  ActivityIndicator,
  Button as RNButton,
} from "react-native";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MenuButton from "../components/MenuButton";
import { initBox } from "../redux/actions/box";
import { RepositStyles, errorColors } from "../utils/styles";
import Icon from "react-native-vector-icons/FontAwesome";
import goTo from "../utils/goTo";
import WebHeading from "../components/WebHeading";

const questionCircle = (
  <Icon name="warning" size={14} color={errorColors.orange} />
);

const mapStateToProps = (state) => ({
  box: state.box,
});

const mapDispatchToProps = (dispatch) => {
  return {
    boxActions: bindActionCreators({ initBox }, dispatch),
  };
};

class Serial extends React.Component {
  constructor(props) {
    super(props);
    this.state = { text: "", validation: "waiting" };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.box.boxExistsStatus === "FOUND" &&
      this.props.box.boxExistsStatus !== "FOUND" &&
      nextProps.box.serialNumber
    ) {
      if (Platform.OS !== "web") {
        Keyboard.dismiss();
      }
      let location;
      if (Platform.OS !== "web") {
        if (this.props.navigation.state.routeName === "SerialValidate") {
          location = "Revalidate";
        } else if (this.props.navigation.state.routeName === "SerialReplace") {
          location = "InternetCheck";
        } else {
          location = "ManualAddress";
        }
      } else {
        if (this.props.path.toLowerCase().includes("serialvalidate")) {
          location = "Revalidate";
        } else if (this.props.path.toLowerCase().includes("serialreplace")) {
          location = "InternetCheck";
        } else {
          location = "ManualAddress";
        }
      }
      goTo(this.props.navigation, location);
    }
  }

  connectionCheck = () => {
    this.props.boxActions.initBox(this.state.text);
  };

  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };
  render() {
    return (
      <View style={styles.wrapper}>
        <WebHeading title="New Setup" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 800, maxHeight: 600 }}>
            <View style={{ flex: 3 }}>
              <View style={{ flex: 1, justifyContent: "space-around" }}>
                <Text style={RepositStyles.headerText}>
                  Confirm Serial Number
                </Text>
                <Text style={RepositStyles.paragraphText}>
                  Please enter the Reposit Box Serial number written on the
                  front of the Reposit Box or the packing slip.
                </Text>
                <View style={styles.textInputWrapper}>
                  <View style={styles.textInputContainer}>
                    <TextInput
                      autoCorrect={false}
                      autoCapitalize="characters"
                      onChangeText={(text) =>
                        this.setState({ text: text.toUpperCase() })
                      }
                      value={this.state.text}
                      style={styles.textInput}
                      onSubmitEditing={() => this.connectionCheck()}
                      placeholder="Serial Number"
                    />
                  </View>
                  {this.props.box.boxExistsStatus === "NOTFOUND" ? (
                    <View>
                      <Text
                        style={{
                          ...RepositStyles.paragraphText,
                          marginTop: 10,
                        }}
                      >
                        {questionCircle} Unable to find Box with that Serial
                        Number in our system
                      </Text>
                    </View>
                  ) : null}
                </View>
              </View>
            </View>
            <View style={{ flex: 1 }} />
            <View
              style={{
                flex: 2,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {this.props.box.boxExistsStatus === "CHECKING" ? (
                <ActivityIndicator />
              ) : (
                <RNButton
                  onPress={() => this.connectionCheck()}
                  title=" Next "
                  color="#4698CB"
                ></RNButton>
              )}
              <Text style={RepositStyles.nextSub}>Customer Address</Text>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
  heading: {
    marginHorizontal: 20,
  },
  headingText: { fontSize: 24, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "left",
    fontSize: 18,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 30,
    marginVertical: 30,
  },
  textInputTitle: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
  },
  bodyText: {
    marginVertical: 10,
  },
  textInput: {
    fontSize: 16,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 300,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Serial);



// WEBPACK FOOTER //
// ./src/containers/Serial.js